enum ChartType {
  AREA = 'area',
  BAR = 'bar',
  CANDLESTICK = 'candlestick',
  LINE = 'line',
  PIE = 'pie',
}

export default ChartType;
